import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";

import AboutBlock from "../components/about-block/AboutBlock";
import useScroll from "../assets/hooks/useScroll";
import "../assets/css/pages/brewery.scss";
import { Dictionary } from "../assets/js/contexts";

const Brewery = ({ dictionary }) => {
  const scroll = useScroll();
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [brewery, setBrewery] = useState([]);
  const [breweryIngridients, setBreweryIngridients] = useState([]);
  const [breweryProcess, setBreweryProcess] = useState([]);
  const ingridientsTitle = {
    en: 'Ingridients',
    hy: 'Բաղադրիչներ',
    ru: 'Ингридиенты'
  }
  useEffect(() =>
  {
    window.scrollTo(0, 0);
    (async () => {
      let rowBrewery = await API.get(config.api.brewery, {}, {}, true);
      setBrewery(rowBrewery);

      let rowBreweryProcess = await API.get(config.api.breweryProcess, {}, { index: "asc" }, true);
      setBreweryProcess(rowBreweryProcess);

      let rowBreweryIngridients = await API.get(config.api.breweryIngridient, {}, {}, true);
      setBreweryIngridients(rowBreweryIngridients);

      setBusy(false);
    })();
  }, [isBusy]);

  if (!isBusy)
    return (
      <Dictionary.Provider value={dictionary}>
        <div id="brewery">
          <div className="header">
            <div className="container animate" data-expand={scroll > 20}></div>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-10 content">
                  <h1>{brewery[0].title[lang]}</h1>
                  {parse(brewery[0]?.desc[lang] ? brewery[0].desc[lang] : '')}
                  <img
                    src={brewery[0].uploads ? `${config.api.API_URL}/${brewery[0].uploads[0].path}` : null}
                    width="100%"
                    style={{ marginTop: 41, marginBottom: 69 }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {breweryProcess.map((item, index) => (
                    <div className="row" key={item._id}>
                      <div className="col-md-3 d-none d-md-flex justify-content-center img-line">
                        <img src={item.uploads ? `${config.api.API_URL}/${item.uploads[0].path}` : null} width='100' height='155' alt="" />
                      </div>
                      <div className="col-md-9">
                        <div style={{ marginBottom: 30 }}>
                          <h4>{item.title[lang]}</h4>
                          {parse(item?.desc[lang] ? item.desc[lang] : '')}
                          <br /><br /><br /><br />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <h3 style={{ marginTop: 141, marginBottom: 72 }}>
                {ingridientsTitle[lang]}
              </h3>
              <div className="row">
                {breweryIngridients.map((item, index) => (
                  <div className="col-md-6" style={{ marginBottom: 88 }} key={item._id} >
                    <div className="d-flex align-items-center" style={{ marginBottom: 36 }}>
                      <img
                        src={`${config.api.API_URL}/${item?.uploads && item?.uploads[0]?.path}`}
                        alt=""
                      />
                      <span className="subtitle">
                        {item.title[lang]}
                      </span>
                    </div>
                    {parse(item?.desc[lang] ? item.desc[lang] : '')}
                  </div>
                ))}
              </div>
            </div>
          </section>
          <AboutBlock
            title={config.aboutUsBlock.brewery.title[lang]}
            subTitle={''}
            content={''}
            buttonText={config.aboutUsBlock.brewery.button[lang]}
            as={'/brewpub'}
            href={'/brewpub'}
          />
        </div>
      </Dictionary.Provider>
    );
  else
    return <Loading type="Oval" color="#FFBE03" className="dms-loader" />
};

export default Brewery;
